import React, { useEffect } from 'react'

declare global {
  interface Window {
    opera?: any // Optionally include opera if you need to use it
    MSStream?: any // Add MSStream to the Window type
  }
}

const Redirect = () => {
  useEffect(() => {
    const getMobileOperatingSystem = () => {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/android/i.test(userAgent)) {
        return 'Android'
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }
      return 'unknown'
    }

    const DetectAndServe = () => {
      let os = getMobileOperatingSystem()
      if (os === 'Android') {
        window.location.href =
          'https://play.google.com/store/apps/details?id=com.edworking.app'
      } else if (os === 'iOS') {
        window.location.href = 'https://apps.apple.com/gb/app/edworking/id1564081031'
      } else {
        window.location.href = 'https://edworking.com'
      }
    }

    DetectAndServe()
  }, [])

  return null // since the component only redirects, we don't render anything
}

export default Redirect
